var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "url(#paint0_linear_26_11607)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6291 32.9831C35.5879 32.9941 35.5447 33 35.5002 33H16.4993C16.4547 33 16.4114 32.9941 16.3703 32.9831L22.2939 27.0627L23.5517 28.3512C24.9028 29.7354 27.0966 29.7355 28.4478 28.3512L29.7055 27.0627L35.6291 32.9831ZM35.9999 32.3504V20.6065C35.9999 20.5466 35.9893 20.4891 35.97 20.4359C35.9404 20.5043 30.0551 26.555 30.0551 26.555L35.9829 32.4797C35.994 32.4385 35.9999 32.3951 35.9999 32.3504ZM16 32.4005V20.6566C16 20.5967 16.0106 20.5392 16.03 20.486C16.0595 20.5544 21.9448 26.605 21.9448 26.605L16.0169 32.5298C16.0059 32.4885 16 32.4452 16 32.4005ZM35.6529 20.0095L28.0895 27.7516C26.9345 28.9349 25.0641 28.9348 23.9092 27.7516C23.9092 27.7516 18.8678 22.591 16.347 20.0107C16.3242 19.9873 35.6529 20.0095 35.6529 20.0095Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26_11607",
    x1: 26,
    y1: 0,
    x2: 26,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E5FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AD4FD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.15dbf3059f41195008f0c53ea1b96377.svg";
export { ForwardRef as ReactComponent };